import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=8c9b72ea&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=8c9b72ea&prod&lang=scss&scoped=true"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=8c9b72ea&prod&scoped=true&lang=css"
import style2 from "./Sidebar.vue?vue&type=style&index=2&id=8c9b72ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9b72ea",
  null
  
)

export default component.exports